/*
  Счётчики окупаемости плитками — §3.11.3.

  08.09.2026, решение владельца: пять счётчиков шли одинаковыми белыми
  карточками в столбик, и по виду было не отличить возвращённые деньги от
  сгоревших. Теперь плитка окрашена по смыслу.

  **Цвет здесь означает ровно то же, что во всём кабинете** (§4.5.3). Красный -
  потеря денег во времени, и он остаётся только у сгоревшего по давности:
  расход на платформу красным не красится, это цена, а не потеря. Зелёный -
  деньги, которые вернулись или не выпали. Величина, которую посчитать нечем,
  цвета не получает вовсе: у неё нет знака.

  Объяснение убрано под значок «i» в правом верхнем углу плитки (08.09.2026,
  решение владельца - приём из Арбитр ДА). Без этого плитки различались бы
  высотой втрое, а само объяснение обязано остаться: каждую цифру здесь можно
  оспорить (§4.5.2).

  Сама плитка живёт в `CounterTile.jsx`: с 09.09.2026 три из этих счётчиков
  стоят ещё и на дашборде, и вид у них обязан быть один.
*/

import { money } from '../api/format.js'
import CounterTile from './CounterTile.jsx'
import InfoHint from './InfoHint.jsx'

const TILES = [
  { key: 'returned', tone: 'good' },
  { key: 'saved_from_expiry', tone: 'good' },
  { key: 'found_by_radar', tone: 'good' },
  { key: 'burned_before_us', tone: 'loss' },
]
/*
  Четыре слагаемых эффекта. Стоимость платформы сюда не входит: она стоит
  наверху рядом с самим эффектом - мы предъявляем клиенту свой счёт вплотную к
  результату, и это сильнее любой презентации при продлении (§3.11.3). Заодно
  ряд получается ровным: пятая плитка уезжала на вторую строку одна.
*/

export default function PaybackTiles({ report }) {
  const effect = report.net_effect
  const tone = effect === null ? 'plain' : Number(effect) < 0 ? 'loss' : 'good'

  return (
    <>
      {/*
        Чистый эффект - главная цифра экрана, ради которой клиент решает,
        продлевать ли договор. Поэтому он стоит первым и во всю ширину, а не
        шестой плиткой в общем ряду.
      */}
      <div className="effect">
        <div className={`tile tile--${tone}`}>
          <div className="tile__head">
            <div className="money__label">Чистый эффект</div>
            <InfoHint
              title="Откуда цифра"
              text={
                effect === null
                  ? report.net_effect_note
                  : 'Возвращённые деньги плюс спасённое от давности и найденное радаром, минус стоимость Арбитра ЖКХ и сопровождения за тот же период.'
              }
            />
          </div>
          {effect === null ? (
            <>
              <div className="money__value money__value--unknown">посчитать нечем</div>
              {/*
                Причина отсутствия эффекта стоит на виду, а не под значком:
                это отказ считать, а не пояснение к посчитанному. Спрятать его -
                значит показать «посчитать нечем» без ответа на «почему».
              */}
              <div className="money__note">{report.net_effect_note}</div>
            </>
          ) : (
            <>
              <div className="money__value money__value--hero">{money(effect)}</div>
              {report.cost_per_returned_rouble === null ? null : (
                <div className="money__note">
                  Стоимость возвращённого рубля - {money(report.cost_per_returned_rouble)}
                </div>
              )}
            </>
          )}
        </div>
        <CounterTile counter={report.spent} />
      </div>

      {/* `grid--even`: плитки этого ряда сравнивают взглядом, и оборвавшаяся
          раньше соседней ломает ряд. В остальных сетках кабинета высота, наоборот,
          по содержимому - карточка не должна пустовать из-за соседки. */}
      <div className="grid grid--even">
        {TILES.map((tile) => (
          <CounterTile key={tile.key} counter={report[tile.key]} tone={tile.tone} />
        ))}
      </div>
    </>
  )
}
